import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { payrollAPI } from '../services/api';

const fmt = n => new Intl.NumberFormat('vi-VN').format(Math.round(n || 0));

const PayslipModal = ({ item, period, onClose }) => {
  if (!item) return null;
  return (
    <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.6)', zIndex: 100, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: '#fff', borderRadius: 16, width: 480, maxHeight: '90vh', overflow: 'auto', boxShadow: '0 20px 60px rgba(0,0,0,0.3)' }}>
        {/* Header */}
        <div style={{ background: 'linear-gradient(135deg,#1e3a8a,#0891b2)', padding: '24px 28px', color: '#fff', borderRadius: '16px 16px 0 0' }}>
          <div style={{ fontSize: 18, fontWeight: 700 }}>PHIẾU LƯƠNG</div>
          <div style={{ opacity: 0.85, fontSize: 13 }}>Kỳ lương: {period}</div>
          <div style={{ marginTop: 12, fontSize: 16, fontWeight: 600 }}>{item.employee_name}</div>
          <div style={{ opacity: 0.8, fontSize: 13 }}>{item.department_name} • {item.employee_code}</div>
        </div>

        <div style={{ padding: 24 }}>
          {/* Earnings */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#22c55e', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 10 }}>💚 THU NHẬP</div>
            {[
              ['Lương cơ bản', item.base_salary],
              ['Các phụ cấp', item.allowances],
              ['Lương OT', item.ot_pay],
              ['Thưởng', item.bonus],
            ].map(([l, v]) => v > 0 && (
              <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f8fafc', fontSize: 14 }}>
                <span style={{ color: '#374151' }}>{l}</span>
                <span style={{ fontWeight: 500, color: '#1e293b' }}>{fmt(v)} ₫</span>
              </div>
            ))}
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', marginTop: 6, fontWeight: 700, fontSize: 15, borderTop: '2px solid #e2e8f0' }}>
              <span style={{ color: '#1e293b' }}>Tổng Thu nhập (Gross)</span>
              <span style={{ color: '#16a34a' }}>{fmt(item.gross_income)} ₫</span>
            </div>
          </div>

          {/* Deductions */}
          <div style={{ marginBottom: 20 }}>
            <div style={{ fontSize: 12, fontWeight: 700, color: '#ef4444', textTransform: 'uppercase', letterSpacing: '0.5px', marginBottom: 10 }}>❌ KHẤU TRỪ</div>
            {[
              ['BHXH (8% NV)', item.bhxh_ee],
              ['BHYT (1.5% NV)', item.bhyt_ee],
              ['BHTN (1% NV)', item.bhtn_ee],
              ['Công đoàn (1%)', item.trade_union_ee],
              ['Thuế TNCN', item.tncn],
              ['Tạm ứng', item.advance],
            ].map(([l, v]) => v > 0 && (
              <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '6px 0', borderBottom: '1px solid #f8fafc', fontSize: 14 }}>
                <span style={{ color: '#374151' }}>{l}</span>
                <span style={{ color: '#ef4444' }}>-{fmt(v)} ₫</span>
              </div>
            ))}
            <div style={{ display: 'flex', justifyContent: 'space-between', padding: '10px 0', marginTop: 6, fontWeight: 700, fontSize: 15, borderTop: '2px solid #e2e8f0' }}>
              <span style={{ color: '#1e293b' }}>Tổng khấu trừ</span>
              <span style={{ color: '#ef4444' }}>-{fmt(item.total_deductions)} ₫</span>
            </div>
          </div>

          {/* Net */}
          <div style={{ background: 'linear-gradient(135deg,#f0fdf4,#dcfce7)', borderRadius: 10, padding: 20, marginBottom: 16, border: '2px solid #86efac' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: 12, color: '#15803d', fontWeight: 600, textTransform: 'uppercase' }}>💵 LƯƠNG THỰC NHẬN (NET)</div>
                <div style={{ fontSize: 26, fontWeight: 800, color: '#15803d' }}>{fmt(item.net_salary)} ₫</div>
              </div>
            </div>
          </div>

          {/* ER contributions */}
          <div style={{ background: '#f8fafc', borderRadius: 8, padding: 14, fontSize: 12, color: '#64748b' }}>
            <div style={{ fontWeight: 600, marginBottom: 8, color: '#374151' }}>Chi phí DN đóng thêm (không trừ NV):</div>
            {[
              ['BHXH DN (17.5%)', item.bhxh_er],
              ['BHYT DN (3%)', item.bhyt_er],
              ['BHTN DN (1%)', item.bhtn_er],
              ['Kinh phí CĐ (2%)', item.trade_union_er],
            ].map(([l, v]) => (
              <div key={l} style={{ display: 'flex', justifyContent: 'space-between', padding: '3px 0' }}>
                <span>{l}</span><span style={{ color: '#7c3aed', fontWeight: 500 }}>{fmt(v)} ₫</span>
              </div>
            ))}
            <div style={{ display: 'flex', justifyContent: 'space-between', borderTop: '1px solid #e2e8f0', marginTop: 6, paddingTop: 6, fontWeight: 600, color: '#374151' }}>
              <span>Tổng CTC</span>
              <span>{fmt(item.gross_income + item.bhxh_er + item.bhyt_er + item.bhtn_er + item.trade_union_er)} ₫</span>
            </div>
          </div>

          <button onClick={onClose} style={{ width: '100%', marginTop: 20, padding: 12, background: '#1e3a8a', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 600 }}>
            Đóng
          </button>
        </div>
      </div>
    </div>
  );
};

export default function PayrollDetailPage() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [run, setRun] = useState(null);
  const [selectedItem, setSelectedItem] = useState(null);
  const [approving, setApproving] = useState(false);
  const [approveError, setApproveError] = useState('');

  useEffect(() => {
    payrollAPI.get(id).then(r => setRun(r.data.data));
  }, [id]);

  const handleApprove = async () => {
    setApproving(true);
    setApproveError('');
    try {
      await payrollAPI.approve(id);
      const res = await payrollAPI.get(id);
      setRun(res.data.data);
    } catch (err) {
      setApproveError(err.response?.data?.message || 'Lỗi phê duyệt');
    } finally {
      setApproving(false);
    }
  };

  if (!run) return <div style={{ padding: 40, textAlign: 'center' }}>⏳ Đang tải...</div>;

  return (
    <div>
      <button onClick={() => navigate('/payroll')}
        style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#64748b', fontSize: 14, marginBottom: 16 }}>
        ← Quay lại
      </button>

      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: 20 }}>
        <div>
          <h1 style={{ fontSize: 24, fontWeight: 700, color: '#1e293b', margin: 0 }}>Bảng lương tháng {run.period}</h1>
          <div style={{ fontSize: 14, color: '#64748b', marginTop: 4 }}>
            {run.employee_count} nhân viên • Tính lúc: {run.calculated_at ? new Date(run.calculated_at).toLocaleString('vi-VN') : '—'}
          </div>
        </div>
        <div style={{ textAlign: 'right' }}>
          {approveError && (
            <div style={{ background: '#fef2f2', border: '1px solid #fecaca', borderRadius: 8, padding: '8px 14px', color: '#dc2626', fontSize: 13, marginBottom: 8 }}>
              ⚠️ {approveError}
            </div>
          )}
          {run.status === 'calculated' && (
            <button onClick={handleApprove} disabled={approving} style={{
              padding: '11px 24px', background: approving ? '#86efac' : '#22c55e', color: '#fff', border: 'none',
              borderRadius: 8, cursor: approving ? 'not-allowed' : 'pointer', fontWeight: 600, fontSize: 14
            }}>
              {approving ? '⏳ Đang duyệt...' : '✓ Phê duyệt bảng lương'}
            </button>
          )}
        </div>
      </div>

      {/* Summary cards */}
      <div style={{ display: 'flex', gap: 14, marginBottom: 20 }}>
        {[
          { label: 'Tổng Gross', value: `${fmt(run.total_gross)} ₫`, color: '#1e3a8a' },
          { label: 'Tổng Net', value: `${fmt(run.total_net)} ₫`, color: '#22c55e' },
          { label: 'BHXH DN đóng', value: `${fmt(run.total_bhxh_er)} ₫`, color: '#7c3aed' },
          { label: 'Tổng chi phí CTC', value: `${fmt((run.total_gross||0)+(run.total_bhxh_er||0))} ₫`, color: '#ef4444' },
        ].map(({ label, value, color }) => (
          <div key={label} style={{ flex: 1, background: '#fff', borderRadius: 10, padding: '16px 20px', boxShadow: '0 1px 4px rgba(0,0,0,0.08)', borderTop: `3px solid ${color}` }}>
            <div style={{ fontSize: 12, color: '#64748b', marginBottom: 4 }}>{label}</div>
            <div style={{ fontSize: 18, fontWeight: 700, color }}>{value}</div>
          </div>
        ))}
      </div>

      {/* Items table */}
      <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 1px 4px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 12 }}>
          <thead>
            <tr style={{ background: '#f8fafc', borderBottom: '2px solid #e2e8f0' }}>
              {['Mã NV', 'Họ tên', 'Phòng ban', 'Gross', 'BHXH+BHYT+BHTN', 'Thuế TNCN', 'NET', 'OT giờ', 'Phiếu lương'].map(h => (
                <th key={h} style={{ padding: '10px 12px', textAlign: 'left', fontSize: 11, fontWeight: 600, color: '#374151', textTransform: 'uppercase' }}>{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {run.items?.map(item => (
              <tr key={item.id} style={{ borderBottom: '1px solid #f8fafc' }}>
                <td style={{ padding: '10px 12px', fontFamily: 'monospace', color: '#1e3a8a', fontWeight: 600, fontSize: 11 }}>{item.employee_code}</td>
                <td style={{ padding: '10px 12px', fontWeight: 500 }}>{item.employee_name}</td>
                <td style={{ padding: '10px 12px', color: '#64748b' }}>{item.department_name}</td>
                <td style={{ padding: '10px 12px', fontWeight: 500 }}>{fmt(item.gross_income)}</td>
                <td style={{ padding: '10px 12px', color: '#ef4444' }}>
                  -{fmt((item.bhxh_ee||0)+(item.bhyt_ee||0)+(item.bhtn_ee||0))}
                </td>
                <td style={{ padding: '10px 12px', color: '#f59e0b' }}>-{fmt(item.tncn)}</td>
                <td style={{ padding: '10px 12px', fontWeight: 700, color: '#16a34a' }}>{fmt(item.net_salary)}</td>
                <td style={{ padding: '10px 12px', textAlign: 'center', color: item.ot_hours > 0 ? '#7c3aed' : '#94a3b8' }}>
                  {item.ot_hours > 0 ? `${parseFloat(item.ot_hours).toFixed(1)}h` : '—'}
                </td>
                <td style={{ padding: '10px 12px' }}>
                  <button onClick={() => setSelectedItem(item)}
                    style={{ padding: '4px 10px', background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 5, cursor: 'pointer', fontSize: 11 }}>
                    Xem
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {selectedItem && <PayslipModal item={selectedItem} period={run.period} onClose={() => setSelectedItem(null)} />}
    </div>
  );
}
